<template>
  <div id="directors-wrapper">
    <div
      id="directors-content"
      class="Directors Work directors-scroller"
    >
      <!-- SEO TITLE -->
      <h1 class="hidden">
        {{ content.seo_title_h1 }}
      </h1>
      <h2 class="hidden">
        {{ content.seo_description }}
      </h2>
      <section class="filters">
        <InertiaLink
          class="filters__item"
          :href="`${route('directors.index')}/`"
          :class="{ active: $page.url === '/directors/' }"
        >
          All
        </InertiaLink>
        <InertiaLink
          v-for="filter in content.director_filters"
          :key="filter"
          class="filters__item"
          :href="`/directors/${filter}/`"
          :class="{
            active: $page.url.includes(filter),
          }"
        >
          <span
            v-for="tax in taxonomies"
            :key="tax.title"
          >
            <span v-if="filter === tax.slug">
              {{ tax.title }}
            </span>
          </span>
        </InertiaLink>
      </section>
      <!-- TODO: delete  -->
      <section
        v-if="$page.url === `/new-directors/`"
        class="filters"
      >
        <InertiaLink
          class="filters__item"
          :href="`${route('newdirectors.index')}/`"
          :class="{ active: $page.url === '/new-directors/' }"
        >
          New All
        </InertiaLink>
        <InertiaLink
          v-for="filter in content.director_filters"
          :key="filter"
          class="filters__item"
          :href="`/new-directors/${filter}/`"
          :class="{
            active: $page.url.includes(filter),
          }"
        >
          <span
            v-for="tax in taxonomies"
            :key="tax.title"
          >
            <span v-if="filter === tax.slug">
              New {{ tax.title }}
            </span>
          </span>
        </InertiaLink>
      </section>

      <section class="Work__bard">
        <div
          v-for="(bardItem, index) in content.home_bard"
          :key="`bardItem${index}`"
          class="Work__bard--container"
        >
          <div v-if="bardItem.type === 'set'">
            <div
              v-if="getPublishedStatus(bardItem) !== false || $page.props.auth.user"
              :class="{outline: getPublishedStatus(bardItem) === false && $page.props.auth.user}"
            >
              <component
                :is="bardItem.attrs.values.type"
                v-if="bardItem.type === 'set'"
                :content="bardItem.attrs.values"
                :position="index"
              />
            </div>
          </div>
        </div>
      </section>

      <span id="directors-content-footer" />
      <TheFooter />
    </div>
  </div>
</template>

<script>
/* Vendor */
import { nextTick } from "vue";
import { InertiaLink } from "@inertiajs/inertia-vue3";

/* Helpers */
import { mainLayout } from "@/helpers/vue-layouts";
import seo from "@/helpers/seo";

/* Mixins */
import page from "@/mixins/page";
import scrollGlobal from "@/mixins/scroll-global";
import loader from "@/mixins/loader";

export default {
  components: {
    InertiaLink
  },

  mixins: [page, scrollGlobal, loader],

  layout: mainLayout,

  props: {
    content: {
      type: Object,
      default: () => {}
    },
    taxonomies: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      // scroll animations
      bgScrollAnimation: null
    };
  },

  created() {
    seo.seoContent(this.content);
  },

  mounted() {
    this.$nextTick(() => {
      // console.log('init images' );
      this.imagesToPreload = document.querySelectorAll("img");
      // console.log('home page imgs',this.imagesToPreload  );
      this.getBackgroundImagesUrl();
      this.loadImages();
    });
  },

  beforeUnmount() {
    this.bgScrollAnimation.scrollTrigger.kill();
  },

  methods: {
    init() {
      this.toggleMenuColor("black", 0, 0);
      this.setScroller("#directors-wrapper", "#directors-content");

      // HEADER ANIMATIONS
      this.bgScrollAnimation = this.$gsap.to(".showBgHeader", {
        scrollTrigger: {
          trigger: "#directors-content",
          markers: false,
          start: "50px top",
          end: "top bottom",
          toggleActions: "play none reverse none"
        },
        height: "100%",
        duration: 0.2,
        ease: "Power2.out"
      });

      setTimeout(() => {
        this.toggleMenuColor("black", 0, 0);
      }, 500);

    },
    getPublishedStatus(bardItem) {
      const values = bardItem?.attrs?.values;
      if (!values) return false;

      const projectKey = Object.keys(values).find(key =>
        key.startsWith('project') &&
        typeof values[key] === 'object' &&
        values[key]?.published !== undefined
      );

      if (!projectKey) {
        return true;
      }

      return !!values[projectKey].published;
    }
  }
};
</script>

<style lang="scss" scoped>
.Directors {
  // Styles in WorkPage
}
</style>
